const parseNumeric = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatTrainingPartVersionCode = part => {
  if (!part?.version) {
    return null;
  }
  return `${part.version}.${part.revision ?? '0'}`;
};

export const resolveMinComplianceFromDate = previousTrainingPart => {
  if (!previousTrainingPart) {
    return null;
  }

  const complianceTo = previousTrainingPart.complianceTo ? new Date(previousTrainingPart.complianceTo) : null;
  if (complianceTo && !Number.isNaN(complianceTo.getTime())) {
    return complianceTo;
  }

  const complianceFrom = previousTrainingPart.complianceFrom ? new Date(previousTrainingPart.complianceFrom) : null;
  if (complianceFrom && !Number.isNaN(complianceFrom.getTime())) {
    return complianceFrom;
  }

  return null;
};

export const resolveCreateTrainingPartDefaults = previousTrainingPart => {
  if (!previousTrainingPart) {
    return {
      version: String(new Date().getFullYear()),
      revision: '1',
      complianceFrom: null,
    };
  }

  const previousVersion = String(previousTrainingPart.version || '').trim();
  const previousRevision = parseNumeric(previousTrainingPart.revision) ?? 0;
  const minComplianceFrom = resolveMinComplianceFromDate(previousTrainingPart);

  return {
    version: previousVersion,
    revision: String(previousRevision + 1),
    complianceFrom: minComplianceFrom,
  };
};

export const validateTrainingPartAgainstPrevious = (values, previousTrainingPart) => {
  if (!previousTrainingPart) {
    return {};
  }

  const errors = {};
  const nextVersion = parseNumeric(values.version);
  const nextRevision = parseNumeric(values.revision);
  const previousVersion = parseNumeric(previousTrainingPart.version);
  const previousRevision = parseNumeric(previousTrainingPart.revision);

  if (nextVersion === null || previousVersion === null) {
    return errors;
  }

  if (nextVersion < previousVersion) {
    errors.version = 'trainingParts.versionBelowPrevious';
    return errors;
  }

  if (nextRevision === null || previousRevision === null) {
    return errors;
  }

  if (nextVersion === previousVersion && nextRevision <= previousRevision) {
    errors.revision = 'trainingParts.revisionBelowPrevious';
  }

  const minComplianceFrom = resolveMinComplianceFromDate(previousTrainingPart);
  if (minComplianceFrom && values.complianceFrom) {
    const complianceFrom = new Date(values.complianceFrom);
    if (!Number.isNaN(complianceFrom.getTime()) && complianceFrom.getTime() < minComplianceFrom.getTime()) {
      errors.complianceFrom = 'trainingParts.complianceFromBeforePrevious';
    }
  }

  return errors;
};
